/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "ledger": {
        "nested": {
          "bookkeeper": {
            "nested": {
              "SweepBizbankMoneyResponse": {
                "nested": {
                  "Error": {
                    "values": {
                      "SWEEP_ERROR_UNKNOWN_DO_NOT_USE": 0,
                      "INSUFFICIENT_FUNDS": 1,
                      "MERCHANT_NOT_BACKFILLED_ON_BOOKS": 2,
                      "TEST_MERCHANT": 3
                    }
                  }
                }
              },
              "ReverseSweepBizbankMoneyResponse": {
                "nested": {
                  "Error": {
                    "values": {
                      "REVERSE_SWEEP_ERROR_UNKNOWN_DO_NOT_USE": 0,
                      "INSUFFICIENT_FUNDS": 1,
                      "MERCHANT_NOT_BACKFILLED_ON_BOOKS": 2,
                      "TEST_MERCHANT": 3
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.ledger?.nested?.bookkeeper?.nested?.SweepBizbankMoneyResponse?.nested?.Error && !$root.nested?.squareup?.nested?.ledger?.nested?.bookkeeper?.nested?.ReverseSweepBizbankMoneyResponse?.nested?.Error) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SweepBizbankMoneyResponse @ squareup/bookkeeper/bookkeeper.proto at 56:1
 */
export const SweepBizbankMoneyResponse = {};
/**
 * SOURCE Error @ squareup/bookkeeper/bookkeeper.proto at 73:3
 */
SweepBizbankMoneyResponse.Error = $root.lookupEnum('squareup.ledger.bookkeeper.SweepBizbankMoneyResponse.Error').values;
/**
 * SOURCE ReverseSweepBizbankMoneyResponse @ squareup/bookkeeper/bookkeeper.proto at 128:1
 */
export const ReverseSweepBizbankMoneyResponse = {};
/**
 * SOURCE Error @ squareup/bookkeeper/bookkeeper.proto at 139:3
 */
ReverseSweepBizbankMoneyResponse.Error = $root.lookupEnum('squareup.ledger.bookkeeper.ReverseSweepBizbankMoneyResponse.Error').values;